module.exports = __webpack_public_path__ + "static/media/graphql-logo.d224cc27.png";